import { IField } from "@/components/Form";
import { IRobot, IRobotStep } from "@/types/robot";

export const STEP_FORM_FIELDS: Record<string, IField[]> = {
  "vision-ai": [
    {
      type: "textarea",
      key: "key",
      label: "Result Key",
    },
    {
      type: "textarea",
      key: "prompt",
      label: "Prompt",
    },
    {
      type: "textarea",
      key: "screenshot",
      label: "Screenshot Key",
    },
  ],
  "remove-element": [
    {
      type: "textarea",
      key: "selector",
      label: "Selector",
    },
  ],
  "screenshot": [
    {
      type: "textarea",
      key: "key",
      label: "Screenshot Key",
    },
    {
      type: "checkbox",
      key: "fullPage",
      label: "Should Capture Full Page?",
    },
    {
      type: "number",
      key: "quality",
      label: "Image Quality",
    },
  ],
  "click": [
    {
      type: "textarea",
      key: "selector",
      label: "Selector",
      cols: 2,
    },
  ],
  "wait": [
    {
      type: "number",
      key: "time",
      label: "Time to wait (ms)",
      cols: 2,
    },
  ],
  "wait-for-selector": [
    {
      type: "textarea",
      key: "selector",
      label: "Selector",
      cols: 2,
    },
  ],
  "html": [
    {
      type: "textarea",
      key: "key",
      label: "Extract Key",
      cols: 2,
    },
  ],
  "extract": [
    {
      type: "textarea",
      key: "key",
      label: "Extract Key",
      cols: 1,
    },
    {
      type: "textarea",
      key: "selector",
      label: "Selector",
      cols: 1,
    },
    {
      type: "list",
      key: "mappings",
      label: "Item Mappings",
      cols: 2,
      subfields: [
        {
          type: "textarea",
          key: "key",
          label: "Mapping Key",
          cols: 1,
        },
        {
          type: "textarea",
          key: "selector",
          label: "Mapping Selector",
          cols: 1,
        },
        {
          type: "textarea",
          key: "attribute",
          label: "Mapping Attribute",
          cols: 1,
        },
      ]
    },
  ],
};

export const STEP_TYPE_OPTIONS = [
  {
    key: "goto",
    label: "Go To Page",
  },
  {
    key: "vision-ai",
    label: "Vision AI",
  },
  {
    key: "remove-element",
    label: "Remove Element",
  },
  {
    key: "screenshot",
    label: "Screenshot",
  },
  {
    key: "extract",
    label: "Extract Data",
  },
  {
    key: "click",
    label: "Click",
  },
  {
    key: "wait",
    label: "Wait for time",
  },
  {
    key: "wait-for-selector",
    label: "Wait for selector",
  },
  {
    key: "html",
    label: "Get Page HTML",
  },
];

export const STEP_TYPE_KEY_TO_LABEL = STEP_TYPE_OPTIONS.reduce((acc, item) => ({
  ...acc,
  [item.key]: item.label
}), {}) as any;
